export const projects = [

    {
        name: "XStream",
        image: "https://res.cloudinary.com/dokgi5r35/image/upload/v1679981881/Screenshot_61_cdilia.png",
        deployed_url: "https://autopay-xstream.vercel.app/",
        source_code_link: "https://github.com/autopay-xstream",
        category: ["Web3"],
        description:
            "Cross-chain streaming service using Connext and Superfluid. Streams can be started to any EVM chain from the any chain.",
        key_techs: ["NextJS", "Tailwind", "Solidity"],
    },
    {
        name: "AutoPay",
        image: "https://res.cloudinary.com/dokgi5r35/image/upload/v1679981881/Screenshot_62_enbszn.png",
        deployed_url: "https://merchant.autopay.finance/",
        source_code_link: "https://github.com/autopay-fragments/autopay-dashboard",
        category: ["Web3"],
        description:
            "Enabling cross-chain recurring payments on-chain. Automating the payment process for merchants and users.",
        key_techs: ["NextJS", "Tailwind", "Solidity"],
    },
    {
        name: "FRAG Early Believers NFT",
        image: "https://res.cloudinary.com/dokgi5r35/image/upload/v1679981882/Screenshot_63_cirtqn.png",
        deployed_url: "https://mint.fragments.money/",
        source_code_link: "https://opensea.io/collection/fragments-early-believers-nft",
        category: ["Web3"],
        description:
            "Fragments Early Believers' NFT. Access to create your own Fragments vault. Entry to the exclusive FRAGmates DAO",
        key_techs: ["React", "Tailwind", "Solidity"],
    },
    {
        name: "Multiethnic FEST",
        image: "https://res.cloudinary.com/dokgi5r35/image/upload/v1679981882/Screenshot_60_i8iy9f.png",
        deployed_url: "https://www.multiethnicfest.com/",
        source_code_link: "https://www.multiethnicfest.com/",
        category: ["Web2"],
        description:
            "Website for Multiethnic FEST 2023. Includes event registration, payment gateway.",
        key_techs: ["NextJS", "Tailwind", "Styled Components"],
    },
    {
        name: "Social Media Backend",
        image: "https://res.cloudinary.com/dokgi5r35/image/upload/v1679985338/Screenshot_66_fuwhnp.png",
        deployed_url: "https://social-media-backend-nbju.onrender.com",
        source_code_link: "https://github.com/Priyanshu1609/social-media-backend/tree/main",
        category: ["Web2"],
        description:
            "A social media backend with user authentication, post creation, like, comment, follow, unfollow, etc.",
        key_techs: ["Express", "MongoDB", "NodeJS"],
    },
    {
        name: "Fragments Landing Page",
        image: "https://res.cloudinary.com/dokgi5r35/image/upload/v1679984239/Screenshot_65_tvoliz.png",
        deployed_url: "https://www.fragments.money/",
        source_code_link: "https://github.com/Team-Gullak",
        category: ["Web2"],
        description:
            "Fragments is a cross-chain DeFi protocol that allows users to create and manage their own vaults.",
        key_techs: ["NextJS", "Tailwind", "Solidity"],
    },
    {
        name: "Fundraiser DAPP",
        image: "https://res.cloudinary.com/dokgi5r35/image/upload/v1679982420/Screenshot_64_br7xtk.png",
        deployed_url: "https://fundraiser-gamma.vercel.app/",
        source_code_link: "https://github.com/Priyanshu1609/fundraiser",
        category: ["Web3"],
        description:
            "Fundraiser DAPP where user can create a campaign and other users can contribute to it.",
        key_techs: ["NextJS", "Tailwind", "Solidity"],
    },
    {
        name: "Watch2Earn",
        image: "https://res.cloudinary.com/dokgi5r35/image/upload/v1679981881/Screenshot_59_w0xtuh.png",
        deployed_url: "https://watch2-earn.vercel.app/",
        source_code_link: "https://github.com/Priyanshu1609/watch-2-earn",
        category: ["web2"],
        description:
            "Watch2Earn is a website where user can watch videos and earn crypto. Videos are ad campaigns run by merchants.",
        key_techs: ["NextJS", "TailwindCSS", "Solidity"],
    },
    {
        name: "Realtime Decentralised Chat App",
        image: "/web3-chat.png",
        deployed_url: "http://web-3-chat-app.vercel.app/",
        source_code_link: "https://github.com/Priyanshu1609/Web-3-chat-app",
        category: ["Web3"],
        description:
            "Basic Realtime Decentralised Chat App using Moralis where user is connected decentrally",
        key_techs: ["React", "Tailwind", "Solidity"],
    },
];